/** @format */
import isPropValid from '@emotion/is-prop-valid';
import React, { FunctionComponent, HTMLProps } from 'react';
import styled from 'styled-components';

import { styles } from './zoomable-element.styles';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type ZoomableElementProps = Pick<
    HTMLProps<HTMLDivElement>,
    'onClick' | 'className' | 'children'
> & { 'data-testid'?: string };

const StyledZoomableElement = styled.div.withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const ZoomableElement: FunctionComponent<ZoomableElementProps> = ({
    children,
    onClick,
    'data-testid': dataTestId = 'interactive-item',
    ...otherProps
}) => {
    return (
        <StyledZoomableElement
            onClick={(event) => onClick?.(event)}
            data-testid={dataTestId}
            {...otherProps}
        >
            {children}
        </StyledZoomableElement>
    );
};
